import Product from '@src/quince-site-common/src/domains/Product'
import productHelper, { CUSTOM_FIELD_NAMES } from '@src/quince-site-common/src/helpers/productHelper'
import { GOLD_BAR_SUBCLASS } from '@src/quince-site-common/src/hooks/cart/constants/goldBar.constants'

export const shouldHideFreeReturns = (product: Product) => {
  return (
    (product.dynamicImages && product.dynamicImages.length > 0) ||
    productHelper.getIsTruthyCustomField(product, CUSTOM_FIELD_NAMES.HIDE_FREE_RETURN_COMP_PRICING) ||
    !productHelper.getIsReturnable(product) ||
    isProductOfNonReturnableSubDepartment(product) ||
    isProductOfNonReturnableSubclass(product)
  )
}

const NON_RETURNABLE_SUB_DEPARTMENTS = [350]
const isProductOfNonReturnableSubDepartment = (product: Product) => {
  const subDepartmentId = product.classification?.subDepartment?.id
  return Boolean(subDepartmentId && NON_RETURNABLE_SUB_DEPARTMENTS.includes(subDepartmentId))
}

const NON_RETURNABLE_SUBCLASSES = [GOLD_BAR_SUBCLASS]
const isProductOfNonReturnableSubclass = (product: Product) => {
  const subClassId = product.classification?.subClass?.id
  return Boolean(subClassId && NON_RETURNABLE_SUBCLASSES.includes(subClassId))
}
